import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import SidebarProposal from '../../layouts/sidebarProposal/SidebarProposal'
import './styles.less'
import InviteToProjectWidget from '../../widgets/projectProposal/inviteToProject/InviteToProjectWidget'
import PanalLoadingTemplate from '../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import BtnEditAll from '../../components/buttons/btnEditAll/BtnEditAll'
import { startLoading, doneLoading } from '../../utils/loading'
import { getInviteForm } from '../../redux/actions/inviteToProject'
import ErrorWidget from '../../widgets/errorWidget/ErrorWidget'
import { getIsEditAll, setIsEditAll, handleOnChangeIsEdit } from '../../utils/widget'
import ContentHeader from '../../components/ContentHeader/ContentHeader'

export default function InviteToProject() {
  const [isEditWidget, setIsEditWidget] = useState({})
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [showEditAll, setShowEditAll] = useState()
  const [error, setError] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const handleGetSchema = async (proposalId) => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getInviteForm(proposalId)
      setSchema(response)
      // setIsEditWidget({
      //   inviteProject: _schema.forms?.inviteProject?.id ? false : true,
      // })

      // setShowEditAll(!_schema.forms?.inviteProject?.disabled)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  useEffect(() => {
    console.log('load inviteToProject projectId', projectId)

    projectId && handleGetSchema(projectId)
  }, [])

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      {schema && (
        <SidebarProposal>
          <ContentHeader header={schema.header} subHeader={schema.subHeader} />

          {/* {showEditAll && (
            <BtnEditAll
              onClickEditAll={getIsEditAll(isEditWidget)}
              setOnClickEditAll={(_isEdit) => setIsEditAll(_isEdit, isEditWidget, setIsEditWidget)}
            />
          )} */}

          {schema?.forms?.inviteProject && (
            <InviteToProjectWidget
              showCommandButton={true}
              schema={schema.forms.inviteProject}
              // isEdit={isEditWidget.inviteProject}
              // onChangeIsEdit={(_isEdit) =>
              //   handleOnChangeIsEdit('inviteProject', _isEdit, setIsEditWidget)
              // }
            />
          )}
        </SidebarProposal>
      )}
    </>
  )
}
